export default function mapLoginPayload(email) {
  return {
    email: email.trim().toLowerCase(),
  };
}